import {
  FETCH_EVENT_LOG_START,
  FETCH_EVENT_LOG_SUCCESS,
  FETCH_EVENT_LOG_ERROR,
  FETCH_EVENT_LOGS_START,
  FETCH_EVENT_LOGS_SUCCESS,
  FETCH_EVENT_LOGS_ERROR,
} from '../../constants/ActionTypes';
import { logsAxios } from '../../util/Api';

// eslint-disable-next-line import/prefer-default-export
export const getEvents = (params) => (dispatch) => {
  dispatch({ type: FETCH_EVENT_LOGS_START });
  logsAxios.get(`events/${params ? `?${params}` : ''}`).then(({ data, headers }) => {
    dispatch({
      type: FETCH_EVENT_LOGS_SUCCESS,
      payload: data.data,
      currentPage: Number(headers['content-range'].split('-')[0]),
      totalRecords: Number(headers['content-range'].split('/')[1]),
    });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: FETCH_EVENT_LOGS_ERROR, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
  });
};

export const getEventById = (id) => (dispatch) => {
  dispatch({ type: FETCH_EVENT_LOG_START });
  logsAxios.get(`/events/${id}`).then(({ data }) => {

    dispatch({
      type: FETCH_EVENT_LOG_SUCCESS,
      payload: data.data
    });

  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: FETCH_EVENT_LOG_ERROR, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
  });
};
